import React, { useState, useEffect } from "react";
import Rotas from "./components/routes/Rotas";
import * as apiCarros from "./api/apiCarros";
import * as apiMotas from "./api/apiMotas";
import * as apiBarcos from "./api/apiBarcos";
import * as apiEmpresa from "./api/apiEmpresa";
import * as apiJson from "./api/apiJson";
import useScriptWidgetsWhats from "./components/hooks/useScriptWidgetsWhats";
import useGaTracker from "./components/hooks/useGaTracker";
import useStateWithLocalStorage from "./components/hooks/useStateWithLocalStorage ";
import useMediaQuery from "./components/hooks/useMediaQuery ";
import Siteholder from "./components/tools/placeholder/Siteholder";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "styled-components";
import ReactSEOMetaTags from "react-seo-meta-tags";
import { lightTheme, darkTheme } from "./config/theme";
import GlobalTheme from "./config/global";
import CookieConsentir from "./components/tools/cookies/CookieConsentir";
import Snow from "./components/tools/snowFall/Snow";
import AuthContext from "./components/hooks/AuthContext";

const global = require("./config/config");
export default function App() {
  const { state, dispatch } = React.useContext(AuthContext);
  const [infoJson, setInfoJson] = useState([]);
  const [metaTags, setMetaTags] = useState([]);

  const [selectedCarsComparar, setSelectedCarsComparar] =
    useStateWithLocalStorage("myValueInLocalStorage");
  const [showModalComparison, setShowModalComparison] = useState(false);
  const [textoModal, setTextoModal] = useState(false);
  const [allinfoText, setAllinfoText] = useState([]);

  useEffect(() => {
    const getJson = async () => {
      const info = await apiJson.infoJson();
      setInfoJson(info);
    };

    getJson();
  }, []);
  useEffect(() => {
    const getAllinfoText = async () => {
      const info = await apiEmpresa.getInfoTextos(infoJson);
      setAllinfoText(info);
      dispatch({ type: "AddInfoText", info: info });
    };
    Object.keys(infoJson).length !== 0 && getAllinfoText();
  }, [infoJson, dispatch]);

  useScriptWidgetsWhats(infoJson);
  useGaTracker(infoJson);

  useEffect(() => {
    const getViaturas = async () => {
      const viaturas = await apiCarros.getListaViaturas(infoJson);
      let motas = [];
      let barcos = [];

      if (infoJson.Stand.Easymanager) {
        motas = [];
        barcos = [];
      } else {
        motas = await apiMotas.getListaMotas(infoJson);
        barcos = await apiBarcos.getListaBarcos(infoJson);
      }

      if (infoJson.Layout.TudoJunto) {
        const vJuntas = viaturas
          .concat(motas)
          .concat(barcos)
          .sort(
            (a, b) => new Date(b.UltimaAlteracao) - new Date(a.UltimaAlteracao)
          );
        dispatch({ type: "AddLista", list: vJuntas });
      } else {
        dispatch({ type: "AddLista", list: viaturas });
      }
      dispatch({ type: "AddMotas", list: motas });
      dispatch({ type: "AddBarcos", list: barcos });

      const Carros = viaturas.filter((carro) => {
        return (
          carro.Estado.Id !== 41 && global.carrosNormais.includes(carro.Tipo.Id)
        );
      });
      dispatch({ type: "AddCarros", list: Carros });

      const Comercias = viaturas.filter((carro) => {
        return (
          carro.Estado.Id !== 41 &&
          global.carrosComerciais.includes(carro.Tipo.Id)
        );
      });
      dispatch({ type: "AddComercias", list: Comercias });

      const Classicos = viaturas.filter((carro) => {
        return carro.Estado.Id === 41;
      });
      dispatch({ type: "AddClassicos", list: Classicos });
    };
    if (Object.keys(infoJson).length !== 0) {
      getViaturas();
    }
  }, [infoJson, dispatch]);

  useEffect(() => {
    const getEmpresas = async () => {
      const info = await apiEmpresa.getInfoEmpresa(infoJson);

      dispatch({ type: "AddInfo", list: info });

      const infoPrincipal = info.filter((empresa) => {
        return empresa.Principal === true;
      });

      dispatch({ type: "AddPrincipal", list: infoPrincipal });
    };

    Object.keys(infoJson).length !== 0 && getEmpresas();
  }, [state.codPontoVenda, infoJson, dispatch]);

  const isDesktop = useMediaQuery("(min-width: 992px)");

  const addToCompare = (item) => {
    let numLimit;
    !isDesktop ? (numLimit = 2) : (numLimit = 3);
    if (
      selectedCarsComparar.length >= 1 &&
      item.Viatura !== selectedCarsComparar[0].Viatura
    ) {
      setShowModalComparison(true);
      setTextoModal(
        " O viatura que tentaste adicionar não é compatível com os restantes viaturas no comparador."
      );
      return;
    }
    if (selectedCarsComparar.length >= numLimit) {
      setShowModalComparison(true);
      setTextoModal(
        " O limite de viaturas no comparador foi atingido. Por favor, remove uma viatura para poderes adicionar mais."
      );
    } else {
      setSelectedCarsComparar((selectedCarsComparar) => [
        ...selectedCarsComparar,
        item,
      ]);
    }
  };

  const removeFromCompare = (item) => {
    const filteredItems = selectedCarsComparar.filter(
      (product) => product.CodViatura !== item.CodViatura
    );
    setSelectedCarsComparar((selectedCarsComparar) => filteredItems);
  };
  const removeFromCompareAll = () => {
    setSelectedCarsComparar([]);
  };

  useEffect(() => {
    selectedCarsComparar.length > 0 &&
      (document.body.style.overflow = "visible");
  }, [selectedCarsComparar]);

  return (
    <>
      {Object.keys(infoJson).length !== 0 && (
        <>
          <ThemeProvider
            theme={infoJson.Layout.ThemeDark ? darkTheme : lightTheme}
          >
            <GlobalTheme infoJson={infoJson} />
            <HelmetProvider>
              <ReactSEOMetaTags
                render={(el) => (
                  <Helmet>
                    {/* Chrome, Firefox OS and Opera  */}
                    <meta
                      name="theme-color"
                      content={infoJson.Cores.FundoTransparentScroll}
                    />
                    {/* Windows Phone  */}
                    <meta
                      name="msapplication-navbutton-color"
                      content={infoJson.Cores.FundoTransparentScroll}
                    />
                    {/* iOS Safari  */}
                    <meta
                      name="apple-mobile-web-app-status-bar-style"
                      content={infoJson.Cores.FundoTransparentScroll}
                    />
                    {infoJson.Stand.Lead2team.existe && (
                      <script type="text/javascript">
                        {` 
              (function (w,d,s,o,f,js,fjs,mpd) { w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
              mpd = d.createElement('div');
              mpd.id = 'widget_'+o; d.body.appendChild(mpd); js = d.createElement(s), fjs = d.getElementById('widget_'+o); js.id = o; js.src = f; 
              js.async = 1; fjs.parentNode.insertBefore(js, fjs); }(window, document, 'script', 'lead2team', 'https://online.lead2team.com/widget/widget.js'));
              lead2team('init', { apiKey: '${infoJson.Stand.Lead2team.apiKey}' });
              lead2team('lead2team', { groups: '', locations: ''}); 
            `}
                      </script>
                    )}

                    {el}
                  </Helmet>
                )}
                website={metaTags.fullWebsiteData}
        
                facebook={metaTags.facebookData}
                twitter={metaTags.twitterData}
                blogPost={metaTags.blogPostData}
              />
            </HelmetProvider>
            {infoJson.Stand.Snowfall.existe && <Snow infoJson={infoJson} />}

            {state.allLista.length === 0 ? (
              <>
                <Siteholder infoJson={infoJson} />
              </>
            ) : (
              <>
                <Rotas
                  setMetaTags={setMetaTags}
                  infoJson={infoJson}
                  selectedItems={selectedCarsComparar}
                  addToCompare={addToCompare}
                  removeFromCompare={removeFromCompare}
                  allinfoText={allinfoText}
                  selectedCarsComparar={selectedCarsComparar}
                  removeFromCompareAll={removeFromCompareAll}
                  setTextoModal={setTextoModal}
                  textoModal={textoModal}
                  setShowModalComparison={setShowModalComparison}
                  showModalComparison={showModalComparison}
                />
              </>
            )}
            <CookieConsentir />
          </ThemeProvider>
        </>
      )}
    </>
  );
}
